/**
 * Card kết quả: link hoàn tiền vừa tạo + mua ngay / copy / chia sẻ.
 *
 * "Mua ngay" là hành động chính: đa số user dán link xong là muốn mua liền, bắt họ
 * copy rồi tự mở sàn là thừa một bước.
 */
import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheck, faShare, faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { PLATFORM_INFO } from "./detect-platform";

function LinkConverterResult({ link, platform }) {
    const [copied, setCopied] = useState(false);
    const meta = platform ? PLATFORM_INFO[platform] : null;

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(link);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }, [link]);

    const handleShare = useCallback(() => {
        if (navigator.share) navigator.share({ text: link }).catch(() => {});
        else handleCopy();
    }, [link, handleCopy]);

    return (
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl">
            <div className="flex items-center gap-3 mb-3">
                {meta && (
                    <div className={`w-9 h-9 rounded-lg border-2 ${meta.borderColor} bg-surface flex items-center justify-center shrink-0`}>
                        <img src={meta.logo} alt="" className="w-5 h-5 object-contain" />
                    </div>
                )}
                <div>
                    <p className="text-sm font-semibold text-green-700">Link hoàn tiền đã sẵn sàng</p>
                    <p className="text-xs text-content-3">
                        {meta ? `${meta.name} · đã gắn mã của bạn` : "Đã gắn mã của bạn"}
                    </p>
                </div>
            </div>

            <div className="bg-surface rounded-lg p-3 border border-green-100 break-all text-sm text-content select-all">
                {link}
            </div>

            <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-3 w-full flex items-center justify-center gap-2 py-3 rounded-xl font-bold text-white text-sm transition-all active:scale-[0.98] ${
                    meta ? meta.buttonColor : "bg-brand-red hover:opacity-90"
                }`}
            >
                <FontAwesomeIcon icon={faCartShopping} />
                Mua ngay với hoàn tiền
            </a>

            <div className="flex gap-2 mt-3">
                <button
                    onClick={handleCopy}
                    className={`flex-1 py-2.5 rounded-xl font-semibold text-sm text-white transition-all active:scale-[0.98] ${
                        copied ? "bg-green-500" : "bg-green-600 hover:bg-green-700"
                    }`}
                >
                    <FontAwesomeIcon icon={copied ? faCheck : faCopy} className="mr-2" />
                    {copied ? "Đã copy!" : "Copy Link"}
                </button>
                <button
                    onClick={handleShare}
                    className="px-5 py-2.5 rounded-xl font-semibold text-sm bg-blue-500 text-white hover:bg-blue-600 active:scale-[0.98] transition-all"
                >
                    <FontAwesomeIcon icon={faShare} />
                </button>
            </div>
        </div>
    );
}

export default LinkConverterResult;
